import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getConsumableStockAccess, getReagentStockAccess } from '../services/api';

export type StockManagerKind = 'reagent' | 'consumable';

function roleCanManageStock(role: string | null, kind: StockManagerKind): boolean {
  if (role === '管理员' || role === '超级管理员') return true;
  if (kind === 'reagent' && role === '试剂管理员') return true;
  if (kind === 'consumable' && role === '耗材管理员') return true;
  return false;
}

/** 管理员 / 物资管理员 / 审批设置中的审批人可管理库存（增删改） */
export function useStockManagerAccess(kind: StockManagerKind) {
  const { role } = useAuth();
  const immediate = roleCanManageStock(role, kind);
  const [canManage, setCanManage] = useState(immediate);
  const [loading, setLoading] = useState(!immediate);

  useEffect(() => {
    if (immediate) {
      setCanManage(true);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const response =
          kind === 'reagent' ? await getReagentStockAccess() : await getConsumableStockAccess();
        if (!cancelled) {
          setCanManage(Boolean(response.success && response.data?.canManage));
        }
      } catch {
        if (!cancelled) setCanManage(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [immediate, kind]);

  return { canManage, loading };
}
